export default "__VITE_ASSET__CHWphFVp__"